// extracted by mini-css-extract-plugin
var _1 = "EntityPill-module__group--lqQBM";
var _2 = "EntityPill-module__iconContainer--eojD9";
var _3 = "EntityPill-module__pill--_gr2y";
var _4 = "EntityPill-module__post--VVhgN";
var _5 = "EntityPill-module__remove--UjGHD";
var _6 = "EntityPill-module__topic--lPoEa";
var _7 = "EntityPill-module__user--rY4F_";
var _8 = "EntityPill-module__userFocused--zgWBo";
export { _1 as "group", _2 as "iconContainer", _3 as "pill", _4 as "post", _5 as "remove", _6 as "topic", _7 as "user", _8 as "userFocused" }
